import React, { useEffect } from "react";
import {
  Users,
  UserPlus,
  FilePlus,
  ClipboardList,
  CreditCard,
  Receipt,
  LogOut,
  Home
} from "lucide-react";
import { Link, useLocation } from "react-router-dom";

const Sidebar = ({
  collapsed,
  setCollapsed,
  forceCollapsed = false,
}) => {
  const location = useLocation();

const [userOpen, setUserOpen] = React.useState(false);
const [rtiOpen, setRtiOpen] = React.useState(false);
const [occupancyOpen, setOccupancyOpen] = React.useState(false);
const [developerOpen, setDeveloperOpen] = React.useState(false);
  // 🔥 AUTO COLLAPSE ON ROUTE CHANGE + FORCE COLLAPSE
  useEffect(() => {
    setCollapsed(forceCollapsed);
  }, [location.pathname, forceCollapsed]);

  // ✅ FULL LOGOUT FUNCTION
  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/login";
  };

  const isActive = (to) => location.pathname === to;

  const menuItem = (to, icon, label) => (
    <Link
      to={to}
      className={`flex items-center px-3 py-2 rounded-xl transition hover:bg-blue-50 ${
        collapsed ? "justify-center" : "gap-3"
      } ${isActive(to) ? "bg-blue-50 text-blue-600 font-medium" : "text-gray-700"}`}
    >
      <span className={isActive(to) ? "text-blue-600" : "text-gray-500"}>
        {icon}
      </span>
      {!collapsed && <span>{label}</span>}
    </Link>
  );

  const section = (title, children) => (
    <div className="space-y-1">
      {!collapsed && (
        <p className="text-xs uppercase text-gray-500 font-medium px-3 mt-4 mb-2">
          {title}
        </p>
      )}
      <div>{children}</div>
    </div>
  );

  return (
    <div
      className={`fixed left-0 top-0 h-screen z-50 transition-all duration-300 ${
        collapsed ? "w-16" : "w-64"
      } text-sm`}
    >
      <div className="h-full bg-white border-r border-gray-200 shadow-sm flex flex-col overflow-hidden">   {/* Changed to overflow-hidden */}

        {/* HEADER */}
        <div className="flex items-center justify-between px-4 py-5 border-b border-gray-100 flex-shrink-0">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-r from-indigo-600 to-blue-600 flex items-center justify-center text-white font-bold">
              P
            </div>
            {!collapsed && (
              <h1 className="text-lg font-semibold text-gray-800">PrintPro</h1>
            )}
          </div>

          <button
            onClick={() => setCollapsed(!collapsed)}
            className="p-1.5 rounded-lg hover:bg-gray-100"
          >
            {collapsed ? "›" : "‹"}
          </button>
        </div>

    {/* MENU */}
<div className="flex-1 overflow-y-auto py-4 px-2 space-y-1 scrollbar-hide">

  {/* DASHBOARD */}
  {menuItem("/", <Home size={20} />, "Dashboard")}

  {/* USER MANAGEMENT */}
  <button
    onClick={() => !collapsed && setUserOpen(!userOpen)}
    className={`w-full flex items-center px-3 py-2 rounded-xl transition hover:bg-blue-50 ${
      collapsed ? "justify-center" : "justify-between"
    }`}
  >
    <div className="flex items-center gap-3">
      <Users size={20} className="text-gray-500" />
      {!collapsed && <span>User Management</span>}
    </div>

    {!collapsed && (
      <span className="text-lg">
        {userOpen ? "−" : "+"}
      </span>
    )}
  </button>

  {!collapsed && userOpen && (
    <div className="ml-8 mt-1 space-y-1">
      {menuItem("/user-add", <UserPlus size={18} />, "Add User")}
      {menuItem("/user-list", <ClipboardList size={18} />, "User List")}
    </div>
  )}

  {/* RTI */}
  <button
    onClick={() => !collapsed && setRtiOpen(!rtiOpen)}
    className={`w-full flex items-center px-3 py-2 rounded-xl transition hover:bg-blue-50 ${
      collapsed ? "justify-center" : "justify-between"
    }`}
  >
    <div className="flex items-center gap-3">
      <FilePlus size={20} className="text-gray-500" />
      {!collapsed && <span>RTI</span>}
    </div>

    {!collapsed && (
      <span className="text-lg">
        {rtiOpen ? "−" : "+"}
      </span>
    )}
  </button>

  {!collapsed && rtiOpen && (
    <div className="ml-8 mt-1 space-y-1">
      {menuItem("/rti-add", <FilePlus size={18} />, "Add RTI")}
      {menuItem("/rti-list", <ClipboardList size={18} />, "RTI List")}
    </div>
  )}

  {/* OCCUPANCY */}
  <button
    onClick={() => !collapsed && setOccupancyOpen(!occupancyOpen)}
    className={`w-full flex items-center px-3 py-2 rounded-xl transition hover:bg-blue-50 ${
      collapsed ? "justify-center" : "justify-between"
    }`}
  >
    <div className="flex items-center gap-3">
      <CreditCard size={20} className="text-gray-500" />
      {!collapsed && <span>Occupancy</span>}
    </div>

    {!collapsed && (
      <span className="text-lg">
        {occupancyOpen ? "−" : "+"}
      </span>
    )}
  </button>

  {!collapsed && occupancyOpen && (
    <div className="ml-8 mt-1 space-y-1">
      {menuItem("/occupancy-add", <CreditCard size={18} />, "Add Charge")}
      {menuItem("/occupancy-list", <Receipt size={18} />, "Charge List")}
    </div>
  )}

  {/* DEVELOPER */}
  <button
    onClick={() => !collapsed && setDeveloperOpen(!developerOpen)}
    className={`w-full flex items-center px-3 py-2 rounded-xl transition hover:bg-blue-50 ${
      collapsed ? "justify-center" : "justify-between"
    }`}
  >
    <div className="flex items-center gap-3">
      <Receipt size={20} className="text-gray-500" />
      {!collapsed && <span>Developer</span>}
    </div>

    {!collapsed && (
      <span className="text-lg">
        {developerOpen ? "−" : "+"}
      </span>
    )}
  </button>

  {!collapsed && developerOpen && (
    <div className="ml-8 mt-1 space-y-1">
      {menuItem("/developer-add", <CreditCard size={18} />, "Add Charges")}
      {menuItem("/developer-list", <Receipt size={18} />, "Charge List")}
    </div>
  )}

</div>

        {/* LOGOUT */}
        <div className="p-3 border-t border-gray-100 flex-shrink-0">
          <button
            onClick={handleLogout}
            className={`w-full flex items-center justify-center py-2.5 rounded-xl bg-gray-50 hover:bg-red-50 hover:text-red-600 transition ${
              collapsed ? "p-2" : "gap-2.5"
            }`}
          >
            <LogOut size={18} className="text-gray-600" />
            {!collapsed && <span className="font-medium">Logout</span>}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;